import { featuredProducts } from '@/mocks/categories';

export default function FeaturedScroll() {
  return (
    <section className="py-20 md:py-28 bg-foreground-950">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-block px-4 py-1.5 border border-background-50/20 text-background-100/60 text-xs font-label font-medium rounded-full mb-4">
              Curated Picks
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-[1.15] max-w-2xl">
              Top Superbuy Spreadsheet Finds
            </h2>
          </div>
          <p className="text-background-100/40 text-sm max-w-xs">
            Hand-picked highlights from the most popular Superbuy spreadsheet categories
          </p>
        </div>

        {/* Horizontal Scroll Cards */}
        <div className="flex gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:px-0 md:mx-0 scrollbar-none">
          {featuredProducts.map((product) => (
            <a
              key={product.name}
              href={product.url}
              target="_blank"
              rel="noopener nofollow"
              className="group shrink-0 w-[280px] md:w-[300px] cursor-pointer"
            >
              <div className="aspect-square rounded-2xl overflow-hidden bg-background-100 mb-5">
                <img
                  src={product.image}
                  alt={`${product.name} - Superbuy Spreadsheet ${product.category} finds`}
                  title={`Superbuy Spreadsheet ${product.category}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3 className="font-heading text-lg font-bold text-background-50 mb-1">
                {product.name}
              </h3>
              <p className="text-sm text-background-100/50">{product.category}</p>
            </a>
          ))}

          {/* View All Card */}
          <div className="shrink-0 w-[280px] md:w-[300px] flex items-center justify-center">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full border-2 border-background-100/20 flex items-center justify-center">
                <i className="ri-arrow-right-line text-2xl text-background-100/40"></i>
              </div>
              <p className="text-background-100/30 text-sm font-label">
                Browse all 14 categories above for the complete collection
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}